import React from 'react';

type RobotIconProps = {
  className?: string;
  size?: number;
  title?: string;
};

/** Simple robot head icon — uses currentColor for theming. */
const RobotIcon: React.FC<RobotIconProps> = ({
  className = '',
  size = 24,
  title = 'AI Assistant',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
    {/* Antenna */}
    <circle cx="12" cy="3.5" r="1.25" fill="currentColor" stroke="none" />
    <path d="M12 4.75V7" />
    {/* Head */}
    <rect x="5" y="7" width="14" height="11" rx="3" />
    {/* Eyes */}
    <circle cx="9" cy="12" r="1.25" fill="currentColor" stroke="none" />
    <circle cx="15" cy="12" r="1.25" fill="currentColor" stroke="none" />
    {/* Mouth */}
    <path d="M9.5 15.5h5" />
    {/* Ears / side bolts */}
    <path d="M5 11.5H3.5M20.5 11.5H19" />
  </svg>
);

export default RobotIcon;
